import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AltroSoggetto } from '../models/altro-soggetto';
import { ResourcefulService } from './resourcefulService';



@Injectable({
  providedIn: 'root'
})
export class AltroSoggettoService extends ResourcefulService<AltroSoggetto>{
  constructor(private httpClient: HttpClient) {
    super(httpClient, AltroSoggetto);
  }
}
